/* tslint:disable:max-line-length */
interface VerifyPostcodeInterface {
    (postcode: any): boolean
}
/**
 * Check if the value typed into input field is valid as a UK postal code
 * It uses the UK Gov Regex code to check it.
 * @param  {event} postcode: [Input field change event used to get it value]
 */
export const verifyPostcode: VerifyPostcodeInterface = (postcode: any) => {
    /**
     * Regex provided by UK Gov
     * http://webarchive.nationalarchives.gov.uk/+/http://www.cabinetoffice.gov.uk/media/291370/bs7666-v2-0-xsd-PostCodeType.htm
     */
    const regex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})/g
    const str = postcode.target.value
    let m
    let matchWord

    while ((m = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++
        }

        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
            if (match !== undefined && groupIndex === 0) {
                matchWord = `${match.toUpperCase()}`
            }
        })
    }
    return matchWord
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/helpers/address.ts